export enum CopilotLogsType {
  LadleClicked = 0,
  Searched,
  Scrolled,
  ExplainDetailsClicked,
  PreviousMessagesClicked,
  AlertAcknowledged,
  AlertDetailsClicked,
  AlertCollapsed,
}
export interface CopilotLog {
  logType: CopilotLogsType;
  actionDate: string;
}

export interface CopilotLogRestModel {
  copilotLogs: CopilotLog[];
}
